<template>
  <v-container class="http404">
    <!-- META-DATA -->
    <vue-headful
      :title="'404: Page Not Found!' + this.$store.state.app.meta.titleSuffix"
      :description="null" />

    <img
      src="@/assets/images/catwrench.jpg"
      class="http404__image">

    <h2>404: Page not found!</h2>
  </v-container>
</template>

<script>
export default {
  name: 'HTTP404',
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.http404
  display: flex
  flex-direction: column
  align-items: center
  &__image
    max-width: 100%
    border-radius: $base-border-radius

</style>
